import { Injectable } from '@angular/core';
import { AgentCampaignWizardService } from '../agent-campaign-wizard.service';
import { AgentCampaignKeys, AgentCampaignStepName, CampaignBio } from '@ag-common-lib/public-api';
import { BehaviorSubject, Observable, map } from 'rxjs';
import { BaseFormService } from '../../../utils/base-form-service';

@Injectable()
export class AgentCampaignBioService extends BaseFormService<CampaignBio> {
  formData$ = new BehaviorSubject<CampaignBio>(this.formData);

  draftBio$: Observable<CampaignBio>;

  constructor(private agentCampaignWizardService: AgentCampaignWizardService) {
    super();
    this.draftBio$ = this.agentCampaignWizardService.draftCampaignData$.pipe(
      map(draftCampaignData => draftCampaignData?.[AgentCampaignStepName.bio]),
    );

    const campaignBio$ = this.agentCampaignWizardService.campaign$.pipe(
      map(campaign => {
        const bio = campaign?.[AgentCampaignKeys.data]?.[AgentCampaignStepName.bio];
        const draftBio = campaign?.[AgentCampaignKeys.draftData]?.[AgentCampaignStepName.bio];

        return Object.assign({}, bio, draftBio);
      }),
    );

    campaignBio$.subscribe(this.getFormData);
  }

  handleNextStepClick = async () => {
    const changes = this.formChangesDetector.getAllChanges();

    if (!changes?.length) {
      this.agentCampaignWizardService.nextStep();
      return;
    }

    const updates = {};

    changes.forEach(([key]) => {
      Object.assign(updates, { [key]: this.formData[key] });
    });
    this.startProgress();
    await this.agentCampaignWizardService
      .handleStepChanges({
        [AgentCampaignStepName.bio]: updates,
      })
      .then(() => {
        this.formChangesDetector.clear();
        this.agentCampaignWizardService.nextStep();
      })
      .finally(() => {
        this.stopProgress();
      });
  };

  private getFormData = (bio?: CampaignBio) => {
    const initialData = Object.assign({}, bio);
    this.formData = new Proxy(initialData, {
      set: (target, prop, value, receiver) => {
        const prevValue = target[prop];

        if (value !== prevValue) {
          this.formChangesDetector.handleChange(prop, value, prevValue);
          Reflect.set(target, prop, value, receiver);

          switch (prop) {
            case '':
          }
        }

        return true;
      },
    });

    this.formData$.next(this.formData);
  };
}
